"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MiningColony = void 0;
const Tags_1 = require("../Tags");
const CardType_1 = require("../CardType");
const CardName_1 = require("../../CardName");
const Resources_1 = require("../../Resources");
const BuildColony_1 = require("../../deferredActions/BuildColony");
const Card_1 = require("../Card");
const CardRenderer_1 = require("../render/CardRenderer");
class MiningColony extends Card_1.Card {
    constructor() {
        super({
            cost: 20,
            tags: [Tags_1.Tags.SPACE],
            name: CardName_1.CardName.MINING_COLONY,
            cardType: CardType_1.CardType.AUTOMATED,
            metadata: {
                cardNumber: 'C25',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.production((pb) => pb.titanium(1)).colonies(1);
                }),
                description: 'Increase your titanium production 1 step. Place a colony.',
            },
        });
    }
    canPlay(player) {
        return player.hasAvailableColonyTileToBuildOn();
    }
    play(player) {
        player.game.defer(new BuildColony_1.BuildColony(player, false, 'Select colony for Mining Colony'));
        player.addProduction(Resources_1.Resources.TITANIUM, 1);
        return undefined;
    }
}
exports.MiningColony = MiningColony;
//# sourceMappingURL=MiningColony.js.map